import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useScreen } from '../useScreen';

export const ConfirmOrder = () => {
    const { onSubmit } = useScreen();

    return (
        <WizardScreenContainer footer={{ onSubmit, submitLabel: CommonMessage.BUTTONS.CONTINUE }}>
            <div className='flex h-full flex-col items-center justify-center gap-4 text-center'>
                <span
                    className='text-7xl'
                    role='img'
                    aria-label='celebration'>
                    ✨
                </span>
                <h1 className='text-foreground-default text-xl font-semibold'>
                    <FormattedMessage
                        id='kiosk.wizard.confirm-order.title'
                        defaultMessage='Order confirmed'
                        description='Heading shown after a kiosk product order has been submitted'
                    />
                </h1>
                <p className='text-foreground-default max-w-xl'>
                    <FormattedMessage
                        id='kiosk.wizard.confirm-order.message'
                        defaultMessage='Your order has been created. You will receive a notification when it is on its way.'
                        description='Confirmation message shown after a kiosk product order has been submitted'
                    />
                </p>
            </div>
        </WizardScreenContainer>
    );
};
